import { goto } from "./core/goto";
import { $skxhr } from "./services";
import { sxhr, sxhrHeaders, sxhrRequest } from "fire-wind-water/sxhr";
import { ck, cr } from "fire-wind-water";
import { JsonObject } from "./interface/json";
import { replaceDomain } from "./help/url";
import { $match } from "./template/match";
import { $GrundfosVideoSocket } from "./template/grundfos-video-socket";
import { getChannelParams } from "./core/channel";
import { config } from "./conf/settings";

declare const $: any;
function intercept() {
  setTimeout(() => {
    if (!(window as any).$) {
      intercept();
      return;
    }
    $match.replace(1);
    $.ajaxSetup({
      send: function (config) {
        if (
          config.url.includes("/member/login") ||
          config.url.includes("/member/register")
        ) {
          let m = ck.cookie("miniMipToken");
          if (m) {
            m = m.replace("bearer ", "");
            cr.extend(true, config.data, { miniMipToken: m || null });
          }
        }
        const miniToken = ck.cookie("miniToken");
        const programType = ck.cookie("programType");
        const programId = ck.cookie("programId");
        const programUserId = ck.cookie("programUserId");
        const fromUserId = ck.cookie("fromUserId");
        cr.extend(true, config.data, {
          miniToken: miniToken || null,
          programType: programType || null,
          programId: programId || null,
          programUserId: programUserId || null,
          fromUserId: fromUserId || null,
        });
      },
      success: function (config: any) {
        console.log("skshabby_config = " + config);
        if (config) {
          if (config.cmd === "template.template.getConfig") {
            $match.replace(config.body.content.configInfo);
          }
        }
        return config;
      },
    });
  });
}

intercept();

const wd = window as any;
if (!wd.$sk) {
  wd.$sk = {};
}

if (!wd.$sk.sxhr) {
  ck.json = true;
  sxhrRequest(
    <T>(config: JsonObject): T => {
      if (config.method === "post" || config.method === "POST") {
        //增加来源渠道参数
        const browseChannel = getChannelParams();
        /*console.log(
          "browseChannel_skshabby = " + JSON.stringify(browseChannel)
        );*/
        cr.extend(true, config.data, {
          browseInfo: browseChannel,
          globalUserId: ck.cookie("globalUserId"),
        });
      }
      return config as T;
    },
    (err) => {
      console.log(err);
    }
  );
  sxhrHeaders("Content-Type", "text/plain");
  wd.$sk.sxhr = sxhr;
}

if (!wd.$sk.$skxhr) {
  wd.$sk.$skxhr = $skxhr;
}

if (wd.$s_temp?.jsonParams) {
  goto.getDomain(wd.$s_temp.jsonParams.tenantId);
  $GrundfosVideoSocket.init(wd.$s_temp.jsonParams.tenantId);
} else {
  const dt = setInterval(() => {
    if (wd.$s_temp?.jsonParams) {
      goto.getDomain(wd.$s_temp.jsonParams.tenantId);
      $GrundfosVideoSocket.init(wd.$s_temp.jsonParams.tenantId);
      clearInterval(dt);
    }
  }, 100);
}

wd.$sk.goto = (s: string, b = false) => {
  const m = goto.init(s, b);
  return b ? m : "javascript:;";
};

wd.$sk.replaceDomain = (s: string) => {
  return replaceDomain(s);
};

const link = document.createElement("link");
link.rel = "stylesheet"; // 指定这是一个样式表
link.href = config.cdn + "/ckeditor/assets/temp.css";

document.head.appendChild(link);

function addCkCntent() {
  const dom = document.querySelector(".ck-content");
  const editorDom =
    document.querySelector(".m-pc-content") ||
    document.querySelector(".m-wap-content") ||
    document.querySelector(".g-info-content");
  if (!dom) {
    if (editorDom) {
      editorDom.className = editorDom.className + " ck-content";
    } else {
      setTimeout(() => {
        addCkCntent();
      }, 100);
    }
  }
}

window.addEventListener(
  "load",
  () => {
    addCkCntent();
  },
  false
);
